module.exports = __webpack_public_path__ + "static/media/JCB.bb175e2e.svg";